import Vue from 'vue'
import Router from 'vue-router'

//spa开发，会出现打包后的JavaScript包非常大，这会影响页面加载速度，那我们可以考虑使用懒加载去优化这个问题  resolve解决
const Index = resolve => require(['../pages/index.vue'], resolve) //首页
const ApplyInto = resolve => require(['../pages/ApplyInto.vue'], resolve) //申请人信息
const ApplyIntoS = resolve => require(['../pages/ApplyIntoS.vue'], resolve) //补充信息
const ApplyFile = resolve => require(['../pages/ApplyFile.vue'], resolve) //附件专用页
const ApplyIntoDetail = resolve => require(['../pages/ApplyIntoDetail.vue'], resolve) //申请人信息详情
const ApplyIntoSDetail = resolve => require(['../pages/ApplyIntoSDetail.vue'], resolve) //补充信息详情
const ApplyFileDetail = resolve => require(['../pages/ApplyFileDetail.vue'], resolve) //附件专用页详情
const ApplyFileSupply = resolve => require(['../pages/ApplyFileSupply.vue'], resolve) //退回补充附件页
const ApplyHome = resolve => require(['../pages/ApplyHome.vue'], resolve) //邮储签署空白页
const ApplySigning = resolve => require(['../pages/ApplySigning.vue'], resolve) //邮储签署合同空白页
const InfoAffirm = resolve => require(['../pages/InfoAffirm.vue'], resolve) //信息确认 （个人/企业)
const Paymentagreement = resolve => require(['../pages/Paymentagreement.vue'], resolve) //代付协议
const WithholdMoney = resolve => require(['../pages/WithholdMoney.vue'], resolve) //代付协议内容
const WithholdMoneyJY = resolve => require(['../pages_JY/WithholdMoney.vue'], resolve) //代付协议内容-baas

const BankcarBound = resolve => require(['../pages/BankcarBound.vue'], resolve) //银行卡绑定
const BankcarBounds = resolve => require(['../pages/BankcarBounds.vue'], resolve) //银行卡绑定
const BankcarBoundA = resolve => require(['../pages/BankcarBoundA.vue'], resolve) //银行卡绑定
const ApplyService = resolve => require(['../pages/ApplyService.vue'], resolve) //进件资料
const ViewProfilecopy = resolve => require(['../pages/ViewProfilecopy.vue'], resolve) //征信授权书
const ChangeLoanApplicant = resolve => require(['../pages/ChangeLoanApplicant.vue'], resolve) //变更贷款申请人须知
const AlectronicContract = resolve => require(['../pages/AlectronicContract.vue'], resolve) //信息确认
const investigation = resolve => require(['../pages/investigation.vue'], resolve) //征信授权
const DeductMoney = resolve => require(['../pages/DeductMoney.vue'], resolve) //自动扣款
const ShowWithhold = resolve => require(['../pages/ShowWithhold.vue'], resolve) //展示自动扣款
const verificationCode = resolve => require(['../pages/verificationCode.vue'], resolve) //验证码
const ContractSigning = resolve => require(['../pages/ContractSigning.vue'], resolve) //验证码
const GuaranteeContract = resolve => require(['../pages/GuaranteeContract.vue'], resolve) //担保合同
const NAJINGContract = resolve => require(['../pages/NAJINGContract.vue'], resolve) //担保合同
const NioHome = resolve => require(['../pages/NioHome.vue'], resolve) //担保合同
const DeductionsDetail = resolve => require(['../pages/DeductionsDetail.vue'], resolve) //担保合同
const BillDetail = resolve => require(['../pages/BillDetail.vue'], resolve) //自动扣款详情
const BillBound = resolve => require(['../pages/BillBound.vue'], resolve) //自动扣款绑卡
const EarlyRepayment = resolvue => require(['../pages/EarlyRepayment.vue'], resolve) //提前还款
const FaceRecognition = resolve => require(['../pages/FaceRecognition.vue'], resolve) //人脸识别
const FaceHome = resolve => require(['../pages/FaceHome.vue'], resolve) //
const BOCInformation = resolve => require(['../pages/BOCInformation.vue'], resolve) //中国银行
const BOCDetail = resolve => require(['../pages/BOCDetail.vue'], resolve) //中国银行详情
const FaceInfo = resolve => require(['../pages/FaceInfo.vue'], resolve) //人脸识别提示页
const Fack = resolve => require(['../pages/fack.vue'], resolve) //人脸识别
const DDinvestigation = resolve => require(['../pages/DDinvestigation.vue'], resolve) //《大地财险征信授权书》
const Psbcshowtoast = resolve => require(['../pages/Psbcshowtoast.vue'], resolve) //邮储签约提示页面
const HomeSigning = resolve => require(['../pages/HomeSigning.vue'], resolve)//中间空白页-邮储 支付宝 大地专用

// 经营
const ApplyIntoJY = resolve => require(['../pages_JY/ApplyInto.vue'], resolve) //申请进件-baas
const ApplyIntoJYDetail = resolve => require(['../pages_JY/ApplyIntoDetail.vue'], resolve) //申请进件-baas--详情
const BankcarBoundJY = resolve => require(['../pages_JY/BankcarBound.vue'], resolve) //银行卡绑定
const PaymentagreementJY = resolve => require(['../pages_JY/Paymentagreement.vue'], resolve) //代付协议
const BankcarBoundsJY = resolve => require(['../pages_JY/BankcarBounds.vue'], resolve) //银行卡绑定
const BankcarBoundAJY = resolve => require(['../pages_JY/BankcarBoundA.vue'], resolve) //银行卡绑定
const ApplyServiceJY = resolve => require(['../pages_JY/ApplyService.vue'], resolve) //进件资料
const ViewProfilecopyJY = resolve => require(['../pages_JY/ViewProfilecopy.vue'], resolve) //征信授权书
const AlectronicContractJY = resolve => require(['../pages_JY/AlectronicContract.vue'], resolve) //信息确认
const investigationJY = resolve => require(['../pages_JY/investigation.vue'], resolve) //征信授权
const DeductMoneyJY = resolve => require(['../pages_JY/DeductMoney.vue'], resolve) //自动扣款
const ShowWithholdJY = resolve => require(['../pages_JY/ShowWithhold.vue'], resolve) //展示自动扣款
const verificationCodeJY = resolve => require(['../pages_JY/verificationCode.vue'], resolve) //验证码
const ContractSigningJY = resolve => require(['../pages_JY/ContractSigning.vue'], resolve) //验证码
const GuaranteeContractJY = resolve => require(['../pages_JY/GuaranteeContract.vue'], resolve) //担保合同
const NAJINGContractJY = resolve => require(['../pages_JY/NAJINGContract.vue'], resolve) //担保合同
const NioHomeJY = resolve => require(['../pages_JY/NioHome.vue'], resolve) //担保合同
const DeductionsDetailJY = resolve => require(['../pages_JY/DeductionsDetail.vue'], resolve) //担保合同
const EarlyRepaymentJY = resolvue => require(['../pages_JY/EarlyRepayment.vue'], resolve) //提前还款
const FaceRecognitionJY = resolve => require(['../pages_JY/FaceRecognition.vue'], resolve) //人脸识别
const FaceHomeJY = resolve => require(['../pages_JY/FaceHome.vue'], resolve) //
const BOCInformationJY = resolve => require(['../pages_JY/BOCInformation.vue'], resolve) //中国银行...
const BOCDetailJY = resolve => require(['../pages_JY/BOCDetail.vue'], resolve) //中国银行详情...
const FackJY = resolve => require(['../pages_JY/fack.vue'], resolve) //人脸识别
//新代扣

const WithBillDetail = resolve => require(['../Withhold/BillDetail.vue'], resolve) //自动扣款详情
const WithBankcarBound = resolve => require(['../Withhold/BankcarBound.vue'], resolve) //自动扣款绑卡
const WithBillBound = resolve => require(['../Withhold/BillBound.vue'], resolve) //协议签署
const WidthAlectron = resolve => require(['../Withhold/widthAlectron.vue'], resolve) //代扣条款

//整车账单
const carBill = resolve => require(['../pages_carbill/index.vue'], resolve) //整车账单入口
const carBillPayment = resolve => require(['../pages_carbill/paymentagreement.vue'], resolve) //整车账单协议签署
const carBillDetail = resolve => require(['../pages_carbill/detail.vue'], resolve) //整车账单已绑卡详情

//电池升级
const Car_ContractSigning = resolve => require(['../Automall/ContractSigning.vue'], resolve) //合同签署
const Car_ContractSigningOK = resolve => require(['../Automall/ContractSigningOK.vue'], resolve) //合同签署
const Car_ContractSigningTS = resolve => require(['../Automall/ContractSigningTS.vue'], resolve) //合同签署
const AutomallContract = resolve => require(['../Automall/AutomallContract.vue'], resolve) //合同
const Automall = resolve => require(['../Automall/Automall.vue'], resolve) //
//微众银行
const ApplyIntoS_WZ = resolve => require(['../pages_WZ/ApplyIntoS.vue'], resolve) //微众补充信息
const Modifyapplicant = resolve => require(['../pages_WZ/Modifyapplicant.vue'], resolve) //微众补充信息
const ViewProfile_WZ = resolve => require(['../pages_WZ/ViewProfile.vue'], resolve) //申请资料
const ApplyService_WZ = resolve => require(['../pages_WZ/ApplyService.vue'], resolve) //详情页面
const AuthorizationresultsWZ = resolve => require(['../pages_WZ/Authorizationresults.vue'], resolve) //微众结果
const AuthorizationresultsWZ2 = resolve => require(['../pages_WZ/Authorizationresults2.vue'], resolve) //微众结果
const Wechatapplet = resolve => require(['../pages_WZ/Wechatapplet.vue'], resolve) //微信小程序
//中信银行
const ApplyIntoS_ZX = resolve => require(['../pages_ZX/ApplyIntoS.vue'], resolve) //中信补充信息
const ViewProfile_ZX = resolve => require(['../pages_ZX/ViewProfile.vue'], resolve) //申请资料
const ApplyService_ZX = resolve => require(['../pages_ZX/ApplyService.vue'], resolve) //详情页面
const Financialsolutions = resolve => require(['../pages_ZX/Financialsolutions.vue'], resolve) //中信金融方案
const Authorizationresults = resolve => require(['../pages_ZX/Authorizationresults.vue'], resolve) //中信授权结果
const Authorizationresults2 = resolve => require(['../pages_ZX/Authorizationresults2.vue'], resolve) //中信合同结果
//内部打开第三方页面
const openURL = resolve => require(['../openURL/openURL.vue'], resolve) //

//上海银行
const ApplyIntoSH = resolve => require(['../pages_SH/ApplyIntoS.vue'], resolve) //
const ApplyIntoSHDetail = resolve => require(['../pages_SH/ApplyIntoSDetail.vue'], resolve) //
const SHinvestigation = resolve => require(['../pages/SHinvestigation.vue'], resolve) //《上海征信授权书》

//电汇
const Wiretransfer = resolve => require(['../pages/Wiretransfer.vue'], resolve)//电汇
//DelegatedAuthorization
const DelegatedAuthorization = resolve => require(['../pages/DelegatedAuthorization.vue'], resolve)//《委托划扣授权书》自营
const DelegatedAuthorizationJY = resolve => require(['../pages_JY/DelegatedAuthorization.vue'], resolve)//《委托划扣授权书》baas
const Pdf = resolve => require(['../pdf/pdf.vue'], resolve)// 法卡机构协议书
const ReadPolicy = resolve => require(['../pages/readPolicy.vue'], resolve)// 隐私协议


// baas买断
const md_index = resolve => require(["../pages_md/index.vue"], resolve); //baas买断合同签署
const md_contractSign = resolve => require(["../pages_md/contractSign.vue"], resolve); //baas买断合同签署
const md_termination = resolve => require(["../pages_md/termination.vue"], resolve); //baas买断合同签署
const md_notification = resolve => require(["../pages_md/notification.vue"], resolve); //baas买断合同签署

// 助贷订单补签合同
const sh_index = resolve => require(["../pages_shsupply/index.vue"], resolve); //助贷补签
const sh_sign = resolve => require(["../pages_shsupply/sign.vue"], resolve); //助贷补签合同
const sh_result = resolve => require(["../pages_shsupply/result.vue"], resolve); //助贷补签合同结果页


// 工具箱
const ocrVehicle = resolve => require(["../pages_tools/ocrVehicle.vue"], resolve); //ocr产证

Vue.use(Router);

export default new Router({
    mode: 'history', //去掉#，
    base: '/nioapp', // 基础路径 这个配置也很重要，否则会出现页面空白情况
    routes: [{
        path: "*",
        name: '404',
        redirect: "/NioHome"
    },
    {//首页
        path: '/index',
        name: 'Index',
        component: Index
    },
    {//申请人信息
        path: '/ApplyInto',
        name: 'ApplyInto',
        component: ApplyInto
    },
    {//补充信息
        path: '/ApplyIntoS',
        name: 'ApplyIntoS',
        component: ApplyIntoS,
    },
    {//附件上传
        path: '/applyfile',
        name: 'ApplyFile',
        component: ApplyFile
    },
    {//申请人信息-详情
        path: '/applyintodetail',
        name: 'ApplyIntoDetail',
        component: ApplyIntoDetail
    },
    {//补充信息-详情
        path: '/applyintosdetail',
        name: 'ApplyIntoSDetail',
        component: ApplyIntoSDetail,
    },
    {//附件上传-详情
        path: '/applyfiledetail',
        name: 'ApplyFileDetail',
        component: ApplyFileDetail
    },
    {//补充附件
        path: '/applyfilesupply',
        name: 'ApplyFileSupply',
        component: ApplyFileSupply
    },
    {//上海银行补充信息页
        path: '/applyintoshdetail',
        name: 'ApplyIntoSHDetail',
        component: ApplyIntoSHDetail
    },
    {
        path: '/openURL',
        name: 'openURL',
        component: openURL
    }, {
        path: '/ApplyHome',
        name: 'ApplyHome',
        component: ApplyHome
    }, {
        path: '/ApplySigning',
        name: 'ApplySigning',
        component: ApplySigning
    }, {

        path: '/FaceHome',
        name: 'FaceHome',
        component: FaceHome,
        meta: { keepAlive: false }
    }, {

        path: '/HomeSigning',
        name: 'HomeSigning',
        component: HomeSigning,
        meta: { keepAlive: false }
    },

    {

        path: '/BOCInformation',
        name: 'BOCInformation',
        component: BOCInformation,
        meta: { keepAlive: false }
    }, {
        path: '/FaceInfo',
        name: 'FaceInfo',
        component: FaceInfo,
        meta: { keepAlive: false }
    }, {

        path: '/Fack',
        name: 'Fack',
        component: Fack,
        meta: { keepAlive: false }
    },
    //

    {

        path: '/BOCDetail',
        name: 'BOCDetail',
        component: BOCDetail,
        meta: { keepAlive: false }
    },
    {
        path: '/EarlyRepayment',
        name: 'EarlyRepayment',
        component: EarlyRepayment,
        meta: { keepAlive: false }
    },
    // 申请进件
    {
        path: '/NioHome',
        name: 'NioHome',
        component: NioHome,
        meta: { keepAlive: false }
    },
    {
        path: '/ApplyInto',
        name: 'ApplyInto',
        component: ApplyInto,
        meta: { keepAlive: false }
    },
    //信息确认
    {
        path: '/InfoAffirm',
        name: 'InfoAffirm',
        component: InfoAffirm,
        meta: { keepAlive: false }
    },
    {//人脸识别
        path: '/FaceRecognition',
        name: 'FaceRecognition',
        component: FaceRecognition,
        meta: { keepAlive: false }
    },
    {
        path: '/Paymentagreement',
        name: 'Paymentagreement',
        component: Paymentagreement,
        meta: { keepAlive: false }
    }, {
        path: '/PaymentagreementJY',
        name: 'PaymentagreementJY',
        component: PaymentagreementJY,
        meta: { keepAlive: false }
    }, {
        path: '/WithholdMoney',
        name: 'WithholdMoney',
        component: WithholdMoney,
        meta: { keepAlive: false }
    },
    {
        path: '/WithholdMoneyJY',
        name: 'WithholdMoneyJY',
        component: WithholdMoneyJY,
        meta: { keepAlive: false }
    },
    {
        path: '/BankcarBound',
        name: 'BankcarBound',
        component: BankcarBound,
        meta: { keepAlive: false }
    }, {
        path: '/BankcarBounds',
        name: 'BankcarBounds',
        component: BankcarBounds,
        meta: { keepAlive: false }
    }, {
        path: '/BankcarBoundA',
        name: 'BankcarBoundA',
        component: BankcarBoundA,
        meta: { keepAlive: false }
    },
    {
        path: '/ApplyService',
        name: 'ApplyService',
        component: ApplyService,
        meta: { keepAlive: false }
    },
    {
        path: '/ViewProfilecopy',
        name: 'ViewProfilecopy',
        component: ViewProfilecopy,
        meta: { keepAlive: false }
    },
    {
        path: '/ChangeLoanApplicant',
        name: 'ChangeLoanApplicant',
        component: ChangeLoanApplicant,
        meta: { keepAlive: false }
    },
    {
        path: '/AlectronicContract',
        name: 'AlectronicContract',
        component: AlectronicContract,
        meta: { keepAlive: false }
    }, {
        path: '/investigation',
        name: 'investigation',
        component: investigation,
        meta: { keepAlive: false }
    }, {
        path: '/DDinvestigation',
        name: 'DDinvestigation',
        component: DDinvestigation,
        meta: { keepAlive: false }
    }, {
        path: '/Psbcshowtoast',
        name: 'Psbcshowtoast',
        component: Psbcshowtoast,
        meta: { keepAlive: false }
    },
    {
        path: '/DeductMoney',
        name: 'DeductMoney',
        component: DeductMoney,
        meta: { keepAlive: false }
    }, {
        path: '/ShowWithhold',
        name: 'ShowWithhold',
        component: ShowWithhold,
        meta: { keepAlive: false }
    }, {
        path: '/verificationCode',
        name: 'verificationCode',
        component: verificationCode,
        meta: { keepAlive: false }
    }, {
        path: '/ContractSigning',
        name: 'ContractSigning',
        component: ContractSigning,
        meta: { keepAlive: true }
    }, {
        path: '/GuaranteeContract',
        name: 'GuaranteeContract',
        component: GuaranteeContract,
        meta: { keepAlive: false }
    }, {
        path: '/NAJINGContract',
        name: 'NAJINGContract',
        component: NAJINGContract,
        meta: { keepAlive: false }
    }, {
        path: '/DeductionsDetail',
        name: 'DeductionsDetail',
        component: DeductionsDetail,
        meta: { keepAlive: false }
    },
    {
        path: '/WithBillDetail',
        name: 'WithBillDetail',
        component: WithBillDetail,
        meta: { keepAlive: false }
    },
    {
        path: '/WithBankcarBound',
        name: 'WithBankcarBound',
        component: WithBankcarBound,
        meta: { keepAlive: false }
    }, {
        path: '/WithBillBound',
        name: 'WithBillBound',
        component: WithBillBound,
        meta: { keepAlive: false }
    }, {
        path: '/WidthAlectron',
        name: 'WidthAlectron',
        component: WidthAlectron,
        meta: { keepAlive: false }
    },
    // {
    //     path: '/BillDetail',
    //     name: 'BillDetail',
    //     component: BillDetail,
    //     meta: { keepAlive: false }
    // },
    // 整车账单入口
    {
        path: "/carbill",
        name: "carBill",
        component: carBill
    },
    {
        path: "/carbillPayment",
        name: "carBillPayment",
        component: carBillPayment
    },
    {
        path: "/carbillDetail",
        name: "carBillbDetail",
        component: carBillDetail
    },
    {//bass进件
        path: '/ApplyIntoJY',
        name: 'index',
        component: ApplyIntoJY
    },
    {//bass进件查看资料
        path: '/applyintojydetail',
        name: 'ApplyIntoJYDetail',
        component: ApplyIntoJYDetail
    },
    {

        path: '/FaceHomeJY',
        name: 'FaceHomeJY',
        component: FaceHomeJY,
        meta: { keepAlive: false }
    },
    {

        path: '/BOCInformationJY',
        name: 'BOCInformationJY',
        component: BOCInformationJY,
        meta: { keepAlive: false }
    }, {

        path: '/FackJY',
        name: 'FackJY',
        component: FackJY,
        meta: { keepAlive: false }
    },
    //

    {

        path: '/BOCDetailJY',
        name: 'BOCDetailJY',
        component: BOCDetailJY,
        meta: { keepAlive: false }
    },
    {
        path: '/EarlyRepaymentJY',
        name: 'EarlyRepaymentJY',
        component: EarlyRepaymentJY,
        meta: { keepAlive: false }
    },
    // 申请进件
    {
        path: '/NioHomeJY',
        name: 'NioHomeJY',
        component: NioHomeJY,
        meta: { keepAlive: false }
    },
    {
        path: '/ApplyIntoJY',
        name: 'ApplyIntoJY',
        component: ApplyIntoJY,
        meta: { keepAlive: false }
    },

    {//人脸识别
        path: '/FaceRecognitionJY',
        name: 'FaceRecognitionJY',
        component: FaceRecognitionJY,
        meta: { keepAlive: false }
    },
    {
        path: '/BankcarBoundJY',
        name: 'BankcarBoundJY',
        component: BankcarBoundJY,
        meta: { keepAlive: false }
    }, {
        path: '/BankcarBoundsJY',
        name: 'BankcarBoundsJY',
        component: BankcarBoundsJY,
        meta: { keepAlive: false }
    }, {
        path: '/BankcarBoundAJY',
        name: 'BankcarBoundAJY',
        component: BankcarBoundAJY,
        meta: { keepAlive: false }
    },
    {
        path: '/ApplyServiceJY',
        name: 'ApplyServiceJY',
        component: ApplyServiceJY,
        meta: { keepAlive: false }
    },
    {
        path: '/ViewProfilecopyJY',
        name: 'ViewProfilecopyJY',
        component: ViewProfilecopyJY,
        meta: { keepAlive: false }
    },
    {
        path: '/AlectronicContractJY',
        name: 'AlectronicContractJY',
        component: AlectronicContractJY,
        meta: { keepAlive: false }
    }, {
        path: '/investigationJY',
        name: 'investigationJY',
        component: investigationJY,
        meta: { keepAlive: false }
    }, {
        path: '/DeductMoneyJY',
        name: 'DeductMoneyJY',
        component: DeductMoneyJY,
        meta: { keepAlive: false }
    }, {
        path: '/ShowWithholdJY',
        name: 'ShowWithholdJY',
        component: ShowWithholdJY,
        meta: { keepAlive: false }
    }, {
        path: '/verificationCodeJY',
        name: 'verificationCodeJY',
        component: verificationCodeJY,
        meta: { keepAlive: false }
    }, {
        path: '/ContractSigningJY',
        name: 'ContractSigningJY',
        component: ContractSigningJY,
        meta: { keepAlive: true }
    }, {
        path: '/GuaranteeContractJY',
        name: 'GuaranteeContractJY',
        component: GuaranteeContractJY,
        meta: { keepAlive: false }
    }, {
        path: '/NAJINGContractJY',
        name: 'NAJINGContractJY',
        component: NAJINGContractJY,
        meta: { keepAlive: false }
    }, {
        path: '/DeductionsDetailJY',
        name: 'DeductionsDetailJY',
        component: DeductionsDetailJY,
        meta: { keepAlive: false }
    },
    //车商城-合同签署
    {
        path: '/Car_ContractSigning',
        name: 'Car_ContractSigning',
        component: Car_ContractSigning,
        meta: { keepAlive: false }
    },//车商城-签署成功
    {
        path: '/Car_ContractSigningOK',
        name: 'Car_ContractSigningOK',
        component: Car_ContractSigningOK,
        meta: { keepAlive: false }
    }, {
        path: '/Car_ContractSigningTS',
        name: 'Car_ContractSigningTS',
        component: Car_ContractSigningTS,
        meta: { keepAlive: false }
    }, {
        path: '/AutomallContract',
        name: 'AutomallContract',
        component: AutomallContract,
        meta: { keepAlive: false }
    }, {
        path: '/Automall',
        name: 'Automall',
        component: Automall,
        meta: { keepAlive: false }
    },
    //4.26 微众银行 
    {
        path: '/ApplyIntoS_WZ',
        name: 'ApplyIntoS_WZ',
        component: ApplyIntoS_WZ,
        meta: { keepAlive: false }
    }, {
        path: '/ApplyIntoS_WZ',
        name: 'ApplyIntoS_WZ',
        component: ApplyIntoS_WZ,
        meta: { keepAlive: false }
    }, {
        path: '/ViewProfile_WZ',
        name: 'ViewProfile_WZ',
        component: ViewProfile_WZ,
        meta: { keepAlive: false }
    }, {//
        path: '/Modifyapplicant',
        name: 'Modifyapplicant',
        component: Modifyapplicant,
        meta: { keepAlive: false }
    }, {
        path: '/ApplyService_WZ',
        name: 'ApplyService_WZ',
        component: ApplyService_WZ,
        meta: { keepAlive: false }
    }, {
        path: '/AuthorizationresultsWZ',
        name: 'AuthorizationresultsWZ',
        component: AuthorizationresultsWZ,
        meta: { keepAlive: false }
    },
    {
        path: '/AuthorizationresultsWZ2',
        name: 'AuthorizationresultsWZ2',
        component: AuthorizationresultsWZ2,
        meta: { keepAlive: false }
    },
    //4.28 中信银行 ApplyIntoS_ZX
    {
        path: '/ApplyIntoS_ZX',
        name: 'ApplyIntoS_ZX',
        component: ApplyIntoS_ZX,
        meta: { keepAlive: false }
    },
    //5.7 中信金融方案 Financialsolutions
    {
        path: '/Financialsolutions',
        name: 'Financialsolutions',
        component: Financialsolutions,
        meta: { keepAlive: false }
    }, {
        path: '/Wechatapplet',
        name: 'Wechatapplet',
        component: Wechatapplet,
        meta: { keepAlive: false }
    }, {
        path: '/Authorizationresults',
        name: 'Authorizationresults',
        component: Authorizationresults,
        meta: { keepAlive: false }
    }, {
        path: '/Authorizationresults2',
        name: 'Authorizationresults2',
        component: Authorizationresults2,
        meta: { keepAlive: false }
    }, {
        path: '/ApplyService_ZX',
        name: 'ApplyService_ZX',
        component: ApplyService_ZX,
        meta: { keepAlive: false }
    }, {
        path: '/ViewProfile_ZX',
        name: 'ViewProfile_ZX',
        component: ViewProfile_ZX,
        meta: { keepAlive: false }
    }, {//上海银行补充信息
        path: '/ApplyIntoSH',
        name: 'ApplyIntoSH',
        component: ApplyIntoSH,
        meta: { keepAlive: false }
    }, {//上海银行征信授权书
        path: '/SHinvestigation',
        name: 'SHinvestigation',
        component: SHinvestigation,
        meta: { keepAlive: false }
    }, {//电汇
        path: '/Wiretransfer',
        name: 'Wiretransfer',
        component: Wiretransfer,
        meta: { keepAlive: false }
    }, {//委托划扣授权书
        path: '/DelegatedAuthorization',
        name: 'DelegatedAuthorization',
        component: DelegatedAuthorization,
        meta: { keepAlive: false }
    }, {//发卡机构协议书
        path: '/pdf',
        name: 'Pdf',
        component: Pdf,
        meta: { keepAlive: false }
    }, {//委托划扣授权书baas
        path: '/DelegatedAuthorizationJY',
        name: 'DelegatedAuthorizationJY',
        component: DelegatedAuthorizationJY,
        meta: { keepAlive: false }
    },
    {//隐私协议
        path: '/readpolicy',
        name: 'ReadPolicy',
        component: ReadPolicy,
    },
    {
        //买断合同签署
        path: "/md_index",
        name: "md_index",
        component: md_index
    },
    {
        //买断合同签署
        path: "/md_contractSign",
        name: "md_contractSign",
        component: md_contractSign
    },
    {
        //买断-动力电池租用及服务协议之终止协议
        path: "/md_termination",
        name: "md_termination",
        component: md_termination
    },
    {
        //买断-提前终止动力电池租用及服务告知书
        path: "/md_notification",
        name: "md_notification",
        component: md_notification
    },
    {
        //助贷-补签首页
        path: "/sh_index",
        name: "sh_index",
        component: sh_index
    },
    {
        //助贷-补签合同页
        path: "/sh_sign",
        name: "sh_sign",
        component: sh_sign
    },
    {
        //助贷-补签结果页
        path: "/sh_result",
        name: "sh_result",
        component: sh_result
    },
    {
        //ocr产证
        path: "/ocrVehicle",
        name: "ocrVehicle",
        component: ocrVehicle
    },

    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition && to.meta.keepAlive) return savedPosition;
        return { x: 0, y: 0 }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js